import React, { useEffect, useState } from "react";
import { Header } from "../Core/Header";
import { Footer } from "../Core/Footer";
import ProductCard from "../Core/ProductCard";
import { getProducts } from "../Services/Operations/ProductAPI";
import Slider from "react-slick";

const heroSlides = [
  { src: "Assets/img/ear12.webp", alt: "First slide" },
  { src: "Assets/img/ear14.png", alt: "Second slide" },
  { src: "Assets/img/ear12.webp", alt: "First slide" },
  { src: "Assets/img/ear14.png", alt: "Second slide" },
];

const features = [
  { icon: "fas fa-car-side", title: "Free Shipping", text: "Free on order over 300 rupees" },
  { icon: "fas fa-user-shield", title: "Security Payment", text: "100% security payment" },
  { icon: "fas fa-exchange-alt", title: "30 Day Return", text: "30 day money guarantee" },
  { icon: "fa fa-phone-alt", title: "24/7 Support", text: "Support every time fast" },
];

const services = [
  { img: "Assets/img/earbanner.jpg", title: "Fresh Apples", sub: "20% OFF", tone: "primary" },
  { img: "Assets/img/earbanner1.jpg", title: "Tasty Ear", sub: "Free delivery", tone: "dark" },
  { img: "Assets/img/earbanner2.jpg", title: "Exotic Vegitable", sub: "Discount ₹50", tone: "secondary" },
];

const facts = [
  { icon: "fa fa-users", label: "satisfied customers", value: "3460" },
  { icon: "fa fa-check-circle", label: "quality of service", value: "99.9%" },
  { icon: "fa fa-award", label: "quality certificates", value: "33" },
  { icon: "fa fa-box-open", label: "Available Products", value: "7890" },
];

const TESTIMONIAL_COUNT = 4; // your original had 4 identical placeholder slides

const pageStyles = `
.hp {
  --hp-brand: var(--bs-primary, #81c408);
  --hp-accent: var(--bs-secondary, #ffb524);
  --hp-ink: #1d2823;
  --hp-muted: #5d6a64;
  --hp-line: #e3e8e4;
  --hp-surface: #ffffff;
  /* was grey (#f5f7f3). Now a light gradient built from your own brand + accent colors */
  --hp-wash: linear-gradient(135deg,
    color-mix(in srgb, var(--hp-brand) 14%, #ffffff) 0%,
    color-mix(in srgb, var(--hp-accent) 16%, #ffffff) 100%);
  --hp-r-lg: 20px;
  --hp-r-md: 12px;
  color: var(--hp-ink);
}
.hp img { max-width: 100%; }
.hp-section { padding: clamp(2.5rem, 6vw, 5rem) 0; }
.hp-title { font-size: clamp(1.6rem, 3.2vw, 2.4rem); font-weight: 700; letter-spacing: -0.01em; margin: 0; }
.hp-lead { color: var(--hp-muted); max-width: 42rem; margin: .75rem auto 0; line-height: 1.65; }
.hp-head { text-align: center; margin-bottom: clamp(1.5rem, 4vw, 3rem); }
.hp-head--left { text-align: left; }
 
/* keyboard focus everywhere */
.hp a:focus-visible, .hp button:focus-visible, .hp input:focus-visible {
  outline: 3px solid color-mix(in srgb, var(--hp-brand) 55%, #000);
  outline-offset: 2px;
}
 
/* hero */
.hp-hero { padding: clamp(3rem, 8vw, 6rem) 0; }
.hp-hero__headline { font-size: clamp(2rem, 5vw, 3.4rem); font-weight: 800; line-height: 1.1; letter-spacing: -0.02em; margin-bottom: 1.25rem; }
.hp-search {
  display: flex; align-items: center; gap: .5rem; width: 100%; max-width: 580px;
  background: var(--hp-surface); border: 2px solid var(--hp-accent); border-radius: 999px;
  padding: .35rem .35rem .35rem 1.25rem; box-shadow: 0 10px 30px rgba(29,40,35,.12);
  transition: transform .2s ease, box-shadow .2s ease;
}
.hp-search:focus-within { transform: translateY(-1px); box-shadow: 0 14px 34px rgba(29,40,35,.18); }
.hp-search input { flex: 1; min-width: 0; border: 0; outline: 0 !important; background: transparent; padding: .65rem 0; font-size: 1rem; }
.hp-search button { flex-shrink: 0; border-radius: 999px; padding: .7rem 1.5rem; font-weight: 600; white-space: nowrap; }
.hp-hero__slider { border-radius: var(--hp-r-lg); overflow: hidden; box-shadow: 0 18px 40px rgba(29,40,35,.18); }
.hp-slide { position: relative; padding: 0; }
.hp-slide img { display: block; width: 100%; aspect-ratio: 4 / 3; object-fit: cover; background: var(--hp-accent); }
.hp-slide a {
  position: absolute; left: 1rem; bottom: 1rem; background: rgba(29,40,35,.85); color: #fff;
  padding: .45rem 1.1rem; border-radius: 999px; text-decoration: none; font-weight: 600;
}
.hp-slide a:hover { background: var(--hp-brand); color: #fff; }
 
/* feature strip */
.hp-feature {
  height: 100%; text-align: center; background: var(--hp-surface); border: 1px solid var(--hp-line);
  border-radius: var(--hp-r-md); padding: 1.75rem 1.25rem; transition: transform .2s ease, box-shadow .2s ease;
}
.hp-feature:hover { transform: translateY(-4px); box-shadow: 0 12px 28px rgba(29,40,35,.1); }
.hp-feature__icon {
  width: 64px; height: 64px; margin: 0 auto 1rem; border-radius: 50%;
  display: grid; place-items: center; background: var(--hp-accent); color: #fff; font-size: 1.5rem;
}
.hp-feature h5 { font-weight: 700; margin-bottom: .35rem; }
.hp-feature p { color: var(--hp-muted); margin: 0; }
.hp-slide-pad { padding: 10px; height: 100%; }
 
/* pagination */
.hp-pager { display: flex; align-items: center; justify-content: center; gap: 1.25rem; margin-top: 2rem; flex-wrap: wrap; }
.hp-pager button {
  border: 1px solid var(--hp-brand); background: var(--hp-surface); color: var(--hp-ink);
  border-radius: 999px; padding: .5rem 1.4rem; font-weight: 600; min-height: 44px; transition: background .15s, color .15s;
}
.hp-pager button:hover:not(:disabled) { background: var(--hp-brand); color: #fff; }
.hp-pager button:disabled { opacity: .45; cursor: not-allowed; }
.hp-pager span { font-variant-numeric: tabular-nums; color: var(--hp-muted); min-width: 4.5rem; text-align: center; }
.hp-empty { text-align: center; color: var(--hp-muted); padding: 2.5rem 1rem; border: 1px dashed var(--hp-line); border-radius: var(--hp-r-md); background: var(--hp-wash); width: 100%; }
 
/* promo tiles */
.hp-promo { display: block; text-decoration: none; height: 100%; border-radius: var(--hp-r-lg); overflow: hidden; transition: transform .2s ease, box-shadow .2s ease; }
.hp-promo:hover { transform: translateY(-4px); box-shadow: 0 14px 30px rgba(29,40,35,.16); }
.hp-promo img { display: block; width: 100%; aspect-ratio: 16 / 10; object-fit: cover; }
.hp-promo__body { padding: 1.1rem 1.25rem 1.3rem; text-align: center; }
.hp-promo__body h5 { margin-bottom: .25rem; font-weight: 600; }
.hp-promo__body h3 { margin: 0; font-weight: 800; }
.hp-promo--primary { background: var(--hp-accent); }
.hp-promo--primary .hp-promo__body { background: var(--hp-brand); color: #fff; }
.hp-promo--dark { background: var(--hp-ink); }
.hp-promo--dark .hp-promo__body { background: #fff; color: var(--hp-brand); }
.hp-promo--secondary { background: var(--hp-brand); }
.hp-promo--secondary .hp-promo__body { background: var(--hp-accent); color: var(--hp-ink); }
 
/* banner */
.hp-banner { background: var(--hp-accent); border-radius: var(--hp-r-lg); padding: clamp(1.5rem, 5vw, 3.5rem); }
.hp-banner h2 { font-size: clamp(2rem, 5vw, 3.5rem); font-weight: 800; line-height: 1.05; color: #fff; margin: 0; }
.hp-banner h2 + p { font-size: clamp(1.6rem, 4vw, 2.8rem); font-weight: 400; color: var(--hp-ink); margin: .25rem 0 1rem; }
.hp-banner p.hp-banner__text { font-size: 1.05rem; color: var(--hp-ink); margin-bottom: 1.5rem; max-width: 30rem; }
.hp-banner__btn { background: transparent; border: 2px solid #fff; color: var(--hp-ink); border-radius: 999px; padding: .8rem 2.5rem; font-weight: 700; text-decoration: none; display: inline-block; transition: background .15s; }
.hp-banner__btn:hover { background: #fff; color: var(--hp-ink); }
.hp-banner__media { position: relative; border-radius: var(--hp-r-lg); overflow: hidden; }
.hp-banner__media img { display: block; width: 100%; }
.hp-price {
  position: absolute; top: 12px; left: 12px; width: clamp(88px, 14vw, 120px); aspect-ratio: 1;
  border-radius: 50%; background: #fff; display: grid; place-items: center; font-weight: 800;
  font-size: clamp(1.3rem, 3vw, 1.9rem); box-shadow: 0 8px 20px rgba(0,0,0,.18);
}
 
/* facts */
.hp-facts { background: var(--hp-wash); border-radius: var(--hp-r-lg); padding: clamp(1rem, 3vw, 2rem); }
.hp-fact { height: 100%; background: #fff; border-radius: var(--hp-r-md); padding: 1.75rem 1rem; text-align: center; border: 1px solid var(--hp-line); }
.hp-fact i { font-size: 1.75rem; color: var(--hp-accent); margin-bottom: .75rem; }
.hp-fact h4 { font-size: 1rem; text-transform: capitalize; color: var(--hp-muted); font-weight: 500; margin-bottom: .25rem; }
.hp-fact h1 { font-size: clamp(1.8rem, 3.5vw, 2.4rem); font-weight: 800; margin: 0; font-variant-numeric: tabular-nums; }
 
/* testimonials */
.hp-testimonial-pad { padding: 0 .75rem; }
.hp-testimonial { background: #fff; border: 1px solid var(--hp-line); border-radius: var(--hp-r-lg); padding: 1.5rem; height: 100%; }
.hp-testimonial__who { display: flex; align-items: center; gap: 1rem; margin-bottom: 1rem; }
.hp-testimonial__who img { width: 72px; height: 72px; object-fit: cover; border-radius: 50%; background: var(--hp-accent); flex-shrink: 0; }
.hp-testimonial__who h4 { font-size: 1.25rem; font-weight: 700; margin: 0; }
.hp-testimonial__who p { margin: 0 0 .25rem; color: var(--hp-muted); }
.hp-stars i { color: var(--hp-line); font-size: .9rem; }
.hp-stars i.on { color: var(--hp-brand); }
.hp-testimonial blockquote { margin: 0; padding-top: 1rem; border-top: 1px solid var(--hp-line); color: var(--hp-muted); line-height: 1.65; }
 
@media (max-width: 575.98px) {
  .hp-search { padding-left: 1rem; }
  .hp-search button { padding: .65rem 1.1rem; }
  .hp-slide a { left: .75rem; bottom: .75rem; }
}
@media (prefers-reduced-motion: reduce) {
  .hp *, .hp *::before, .hp *::after { transition: none !important; }
}
`;


/* ---------------------------- PART 2 ----------------------------
   Put these inside your component, above `return`.
   They remove the duplicated product grid + pagination markup while using
   exactly your existing state and props. */


 


const  Home = () => {

  const[allProducts,setAllProducts]=useState([])
  const[productInd,setProductInd]=useState(0)
  const[colLength,setColLength]=useState(0)
  const[mobile,setMobile]=useState(window.innerWidth<567)



      const pageSize = 8;
  const totalPages = Math.ceil(allProducts?.length / pageSize);
  const [page, setPage] = useState(1);

  const currentData = allProducts?.slice((page - 1) * pageSize, page * pageSize);

    function splitDataIntoColumns(data, columnSize = 8) {
  const columns = [];
  const totalColumns = Math.ceil(data.length / columnSize);
  setColLength(totalColumns)




  for (let col = 0; col < totalColumns; col++) {
    const columnData = data.slice(col * columnSize, (col + 1) * columnSize);
    columns.push(columnData);
  }

  return columns;
}


  const fetchAllProducts=async()=>{
    try {
      const response = await getProducts()
      console.log(response.data);


      setAllProducts((response.data))

      

    } catch (error) {
      console.error("Error fetching products:", error);
    }
  }

useEffect(() => {
 
  fetchAllProducts()
}, [])


  const settings = {
    dots: false,
    infinite: true,
    speed: 250,
    slidesToShow: 1,  // show 3 items per view
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,      // enable auto sliding
  autoplaySpeed: 2000, // 2 seconds per slide
  pauseOnHover: false
  };

    const settings1 = {
    dots: false,
    infinite: true,
    speed: 250,
    slidesToShow: 2,  // show 3 items per view
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,      // enable auto sliding
  autoplaySpeed: 2000, // 2 seconds per slide
  pauseOnHover: true,
    responsive: [
    {
      breakpoint: 1024, // below 1024px → Tablet
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
     {
      breakpoint: 567, // below 1024px → Tablet
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
  ]
  };

    const settings2 = {
    dots: false,
    infinite: true,
    speed: 250,
    slidesToShow: 1,  // show 3 items per view
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,      // enable auto sliding
  autoplaySpeed: 2000, // 2 seconds per slide
  pauseOnHover: false
  };
 const productGrid = allProducts ? (
    currentData.map((item, index) => (
      <ProductCard
        key={item.productId ?? index}
        img={item.productImage}
        price={item.retailSalePrice}
        rate={item.retailSaleRate}
        id={item.productId}
        description={" Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod te incididunt"}
        name={item.productName}
        stock={item.stock}
        type={item.bookingTypeId}
      />
    ))
  ) : (
    <p className="hp-empty">Failed to get products</p>
  );

  const pager = (
    <nav className="hp-pager" aria-label="Product pages">
      <button disabled={page === 1} onClick={() => setPage((p) => p - 1)}>Prev</button>
      <span>{page} / {totalPages}</span>
      <button disabled={page === totalPages} onClick={() => setPage((p) => p + 1)}>Next</button>
    </nav>
  );

  return (
    <div>
      
<Header/>
       <div className="hp">
    <style>{pageStyles}</style>

 
    <div className="modal fade" id="searchModal" tabIndex={-1} aria-labelledby="searchModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-fullscreen">
        <div className="modal-content rounded-0">
          <div className="modal-header">
            <h5 className="modal-title" id="searchModalLabel">Search by keyword</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
          </div>
          <div className="modal-body d-flex align-items-center">
            <div className="input-group mx-auto" style={{ maxWidth: 720, width: "90%" }}>
              <input type="search" className="form-control p-3" placeholder="keywords" aria-label="Search keywords" aria-describedby="search-icon-1" />
              <span id="search-icon-1" className="input-group-text p-3"><i className="fa fa-search" /></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    
    <div className="container-fluid hero-header hp-hero">
      <div className="container">
        <div className="row g-5 align-items-center">
          <div className="col-md-12 col-lg-7">
          
            <h1 className="hp-hero__headline">Find the right ear care products</h1>
            <div className="hp-search">
              <input type="number" placeholder="Search" aria-label="Search" />
              <button type="submit" className="btn btn-primary text-white">Submit Now</button>
            </div>
          </div>
          <div className="col-md-12 col-lg-5">
            <div id="carouselId" className="hp-hero__slider">
              <Slider {...settings2}>
                {heroSlides.map((s, i) => (
                  <div className="hp-slide" key={i}>
                    <img src={s.src} alt={s.alt} />
                    <a href="#">Ears</a>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </div>

   
    <div className="container-fluid featurs hp-section">
      <div className="container">
        {mobile ? (
          <Slider {...settings}>
            {features.map((f) => (
              <div className="hp-slide-pad" key={f.title}>
                <div className="hp-feature">
                  <div className="hp-feature__icon"><i className={f.icon} /></div>
                  <h5>{f.title}</h5>
                  <p>{f.text}</p>
                </div>
              </div>
            ))}
          </Slider>
        ) : (
          <div className="row g-4">
            {features.map((f) => (
              <div className="col-md-6 col-lg-3" key={f.title}>
                <div className="hp-feature">
                  <div className="hp-feature__icon"><i className={f.icon} /></div>
                  <h5>{f.title}</h5>
                  <p>{f.text}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>

   
    <div className="container-fluid fruite hp-section" id="all-products">
      <div className="container">
        <div className="hp-head hp-head--left"><h1 className="hp-title">Our Organic Products</h1></div>
        <div className="row g-4">{productGrid}</div>
        {pager}
      </div>
    </div>

    
    <div className="container-fluid service hp-section">
      <div className="container">
        {mobile ? (
          <Slider {...settings}>
            {services.map((s) => (
              <div className="hp-slide-pad" key={s.title}>
                <a href="#" className={`hp-promo hp-promo--${s.tone}`}>
                  <img src={s.img} alt={s.title} />
                  <div className="hp-promo__body"><h5>{s.title}</h5><h3>{s.sub}</h3></div>
                </a>
              </div>
            ))}
          </Slider>
        ) : (
          <div className="row g-4 justify-content-center">
            {services.map((s) => (
              <div className="col-md-6 col-lg-4" key={s.title}>
                <a href="#" className={`hp-promo hp-promo--${s.tone}`}>
                  <img src={s.img} alt={s.title} />
                  <div className="hp-promo__body"><h5>{s.title}</h5><h3>{s.sub}</h3></div>
                </a>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>

    
    <div className="container hp-section">
      <div className="hp-banner">
        <div className="row g-4 align-items-center">
          <div className="col-lg-6">
            <h2>Fresh Exotic Ear</h2>
            <p>in Our Store</p>
            <p className="hp-banner__text">We provide the best ear products for and ear machines</p>
            <a href="#all-products" className="hp-banner__btn">BUY</a>
          </div>
          <div className="col-lg-6">
            <div className="hp-banner__media">
              <img src="Assets/img/ear.jpg" alt="Ear products" />
              <div className="hp-price" aria-label="Price 150 rupees">₹150</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    
    <div className="container-fluid hp-section">
      <div className="container">
        <div className="hp-head">
          <h1 className="hp-title">Bestseller Products</h1>
          <p className="hp-lead">
            We’re thrilled that you love our products! Your support and satisfaction inspire us to keep delivering the best.
          </p>
        </div>
        <div className="row g-4">{productGrid}</div>
        {pager}
      </div>
    </div>

   
    <div className="container-fluid hp-section">
      <div className="container">
        <div className="hp-facts">
          <div className="row g-3 justify-content-center">
            {facts.map((f) => (
              <div className="col-md-6 col-xl-3" key={f.label}>
                <div className="hp-fact">
                  <i className={f.icon} />
                  <h4>{f.label}</h4>
                  <h1>{f.value}</h1>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>

    
    <div className="container-fluid testimonial hp-section">
      <div className="container">
        <div className="hp-head">
          <h4 className="text-primary">Our Testimonial</h4>
          <h1 className="hp-title">Our Client Saying!</h1>
        </div>
        <Slider {...settings1}>
          {Array.from({ length: TESTIMONIAL_COUNT }).map((_, i) => (
            <div className="hp-testimonial-pad" key={i}>
              <div className="hp-testimonial">
                <div className="hp-testimonial__who">
                  <img src="Assets/img/testimonial-1.jpg" alt="Client" />
                  <div>
                    <h4>Client Name</h4>
                    <p>Profession</p>
                    <div className="hp-stars" aria-label="4 out of 5 stars">
                      {[1, 2, 3, 4, 5].map((n) => (
                        <i key={n} className={`fas fa-star${n <= 4 ? " on" : ""}`} />
                      ))}
                    </div>
                  </div>
                </div>
                <blockquote>
                  Lorem Ipsum is simply dummy text of the printing Ipsum has been the industry’s standard dummy text ever since the 1500s,
                </blockquote>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  </div>

      <Footer/>
    </div>
  );
};

export default Home;
